<template>
  <v-container fluid id="about">
    <v-row justify="center" align="center" class="mt-md-16 mt-xs-0">
      <span
        style="
          font-family: Roboto !important;
          font-size: 600 !important;
          color: var(--var2);
        "
        class="text-h6 text-sm-h6 text-md-h5 text-lg-h4 text-xl-h4"
        >About</span
      >
    </v-row>
    <v-row align="center" justify="center">
      <v-col class="wave" cols="12" sm="6" md="6" lg="6" xl="6">
        <p
          class="about pt-4 ml-2 text-subtitle-2 text-sm-body-2 text-md-subtitle-1 text-lg-h6 text-xl-h4"
        >
          I was born and raised in Medan. I have the basic of programmer. I am a
          hard-working person, can work well with a team, and always try to finish my job.
          My short term goal is to expand myself for the better for the company i work
          with.
          <!-- Saya lahir dan besar di Medan. Saya memilki basic seorang programmer.
          Saya adalah orang yang bekerja keras, dapat bekerja dalam tim, dan
          selalu berusaha untuk menyelesaikan pekerjaan. Tujuan jangka pendek
          saya adalah saya dapat mengembangkan diri menjadi lebih baik untuk
          perusahaan yang saya tempati. -->
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
        <div id="wordCloudContainer">
          <canvas :id="canvasId" width="800" height="600" style="width: 100%">
            <p>
              Anything in here will be replaced on browsers that support the canvas
              element
            </p>
            <ul>
              <li v-for="(item, index) in list" :key="index">
                <!-- target="_blank" -->
                <a class="ListTag" @click.prevent="handleClick(item)" :href="item.link"
                  ><span>{{ item.name }}</span></a
                >
              </li>
            </ul>
          </canvas>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.wave {
  background-image: url(@/assets/img/about.svg);
  height: 100%;
  display: block;
  background-repeat: no-repeat;
  background-size: cover;
}
.about {
  font-family: Roboto !important;
  color: var(--var2);
  text-align: justify;
  font-weight: 300;
  mix-blend-mode: difference;
}
</style>

<script>
import TagCanvas from "tag-canvas";
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/lib/utils/resize-event";

export default {
  name: "MyTagCanvas",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    options: {
      type: Object,
    },
  },
  data: () => ({
    list: [
      {
        name: "HTML",
        link: "https://www.w3schools.com/html",
      },
      {
        name: "CSS",
        link: "https://www.w3schools.com/css",
      },
      {
        name: "Javascript",
        link: "https://www.javascript.com",
      },
      {
        name: "ES5/ES6",
        link: "https://www.javatpoint.com/es5-vs-es6",
      },
      {
        name: "TypeScript",
        link: "https://www.typescriptlang.org",
      },
      {
        name: "Bootstrap",
        link: "https://getbootstrap.com",
      },
      {
        name: "REST Api",
        link: "https://restfulapi.net",
      },
      {
        name: "JSON",
        link: "https://www.json.org/json-en.html",
      },
      {
        name: "React Js",
        link: "https://reactjs.org",
      },
      {
        name: "Next Js",
        link: "https://nextjs.org",
      },
      {
        name: "Data Science",
        link:
          "https://www.simplilearn.com/tutorials/data-science-tutorial/what-is-data-science",
      },
      {
        name: "Wordpress",
        link: "https://wordpress.com",
      },
      {
        name: "PHP",
        link: "https://www.php.net",
      },
      {
        name: "Python",
        link: "https://www.python.org",
      },
      {
        name: "Node JS",
        link: "https://nodejs.org/en",
      },
      {
        name: "Git",
        link: "https://git-scm.com",
      },
      {
        name: "GitHub",
        link: "https://github.com",
      },
      {
        name: "lodash",
        link: "https://lodash.com",
      },
      {
        name: "Flutter",
        link: "https://flutter.dev",
      },
      {
        name: "Kotlin",
        link: "https://kotlinlang.org",
      },
      {
        name: "Java",
        link: "https://www.java.com/en",
      },
      {
        name: "C++",
        link: "https://www.cplusplus.com",
      },
      {
        name: "AI",
        link: "https://ai.google",
      },
      {
        name: "Machine learning",
        link:
          "https://www.sas.com/en_us/insights/analytics/machine-learning.html#:~:text=Machine%20learning%20is%20a%20method,decisions%20with%20minimal%20human%20intervention.",
      },
      {
        name: "SASS",
        link: "https://sass-lang.com",
      },
      {
        name: "JQuery",
        link: "https://jquery.com",
      },
      {
        name: "SQL",
        link: "https://dev.mysql.com/downloads/installer",
      },
      {
        name: "MySQL",
        link: "https://dev.mysql.com/downloads/installer",
      },
      {
        name: "GO Language",
        link: "https://go.dev",
      },
      {
        name: "Gulp",
        link: "https://gulpjs.com",
      },
      {
        name: "npm",
        link: "https://www.npmjs.com",
      },
      {
        name: "BEM",
        link: "http://getbem.com",
      },
    ],
    // return {
    //   canvasWidth: null,
    //   canvasHeight: null,
    // };
  }),
  watch: {
    data() {
      this.$nextTick(() => {
        this.reload();
      });
    },
    options: {
      handler() {
        this.update();
      },
    },
  },
  computed: {
    canvasId() {
      return `tag-canvas-${this._uid}`;
    },
    styles() {
      return {
        width: this.width,
        height: this.height,
      };
    },
  },
  methods: {
    handleClick(item) {
      this.$emit("click", item);
    },
    setCanvasSize() {
      const rect = this.$el.getBoundingClientRect();
      this.canvasWidth = rect.width;
      this.canvasHeight = rect.height;
    },
    start() {
      TagCanvas.Start(this.canvasId, null, this.options);
    },
    pause() {
      TagCanvas.Pause(this.canvasId);
    },
    resume() {
      TagCanvas.Resume(this.canvasId);
    },
    reload() {
      TagCanvas.Reload(this.canvasId);
    },
    update() {
      TagCanvas.Update(this.canvasId);
    },
    tagToFront(options) {
      TagCanvas.TagToFront(this.canvasId, options);
    },
    rotateTag(options) {
      TagCanvas.RotateTag(this.canvasId, options);
    },
    setSpeed(speed) {
      TagCanvas.SetSpeed(this.canvasId, speed);
    },
  },
  mounted() {
    this.proxySetCanvasSize = this.setCanvasSize.bind(this);
    addResizeListener(this.$el, this.proxySetCanvasSize);
    this.setCanvasSize();
    this.start();
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.proxySetCanvasSize);
    TagCanvas.Delete(this.canvasId);
  },
};
</script>
